'use client'
import Image from "next/image";
import React, { useState } from "react";
import { Skeleton } from "antd";

export default function FaImage({
  src,
  alt,
  width,
  height,
  classes = "",
  imgClasses = "",
  skeletonStyle = {},
}) {

  const defaultWidth = 200;
  const defaultHeight = 60;

  const imageWidth = width || defaultWidth;
  const imageHeight = height || defaultHeight; 
  return (
    <div
      className={`relative ${classes}`}
      style={{ width: imageWidth }}
    >
   

      <Image
        src={src}
        alt={alt}
        width={imageWidth}
        height={imageHeight}
        className={`transition-opacity duration-300 opacity-100 
       ${imgClasses}`}
      />
    </div>
  );
}
